

<div *ngIf="phoneApp">
  <div class="daPic">
    <div style="text-align: center">
      <div class="titleFont" style="padding-top: 40%; color:white;font-size: 30px; padding-left: 0">RPM Inspections</div>
    </div>
    <table style="width: 100%; height: 100%; padding-top: 1%; margin: 0px">
      <tr>
        <td  >
          <table  class="table-fill" style="height: 100%; text-align: center">
            <tr>
              <td style="vertical-align: top;">
                <div>
                  <mat-card class="speech-bubble3" style="text-align: center;background-color: rgba(238,238,237,1); " xmlns="http://www.w3.org/1999/html">
                    <div class="lowerCaseLetters" style="font-size: 14px;text-align: left; padding-left: 5%;padding-bottom: 3px ">Equipment Number</div>
                    <mat-form-field class="newField" style=" font-size: 17px; min-width: 90%; max-width: 90%; padding: 10px" appearance="outline" >
                      <input [(ngModel)]="containerNum" oninput="this.value = this.value.toUpperCase()"  maxlength="11" style="padding-left: 20px; font-family: Calibri; font-weight: bold"  matInput>
                      <mat-icon (click)="customsAddHold()" matSuffix><img style="vertical-align: center;" src="assets/search.svg" ></mat-icon>
                    </mat-form-field>
                    <div style="display: contents">
                      <div class="errorDiv2" style="font-size: 15px" *ngIf="noContainer">Please Input A Container</div>
                      <div class="errorDiv2" style="font-size: 15px" *ngIf="noContFound">Container Not Found</div>
                    </div>

                  </mat-card>
                </div>

                <div *ngIf="showScreen">


                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div class="lowerCaseLetters" style=" font-size: 14px;text-align: left; padding-left: 5%;padding-bottom: 10px ">Containers On Hold</div>
                      <div class="flex-item2" >
                      <mat-table #table23 style="width:100%" [dataSource]="customsData" multiTemplateDataRows matSort="container"  >

                        <ng-container matColumnDef="check2" >
                          <mat-header-cell *matHeaderCellDef  matTooltip="click to check/uncheck all" class="myHeader" style="padding-left: 5px; padding-right: 5px"><img (click)="checkAll()" style="vertical-align: center;height:26px; width: 26px" src="assets/check_circle_white.png" ></mat-header-cell>
                          <mat-cell style="    flex: 0 0 5% !important; padding-left: 5px" *matCellDef="let row">
                            <mat-checkbox #mySel color="warn" (click)="$event.stopPropagation()"
                                          (change)="masterToggle(row,selection.isSelected(row)) ? selection.toggle(row) : null"
                                          [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="container2" >
                          <mat-header-cell *matHeaderCellDef  class="myHeader">Container</mat-header-cell>
                          <mat-cell style="    flex: 0 0 42% !important;" *matCellDef="let row">{{row.container}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="yard2" >
                          <mat-header-cell *matHeaderCellDef class="myHeader">Yard</mat-header-cell>
                          <mat-cell style="    flex: 0 0 22% !important;"*matCellDef="let row">{{row.yard}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="area2" >
                          <mat-header-cell *matHeaderCellDef  class="myHeader">Location</mat-header-cell>
                          <mat-cell style="    flex: 0 0 22% !important;" *matCellDef="let row" >{{row.area}}</mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="cColumns2; sticky: true"></mat-header-row>
                        <mat-row   *matRowDef="let row; columns: cColumns2;" class="table-row"></mat-row>
                      </mat-table>
                        <div style="text-align: center; padding-top: 25px">
                          <mat-toolbar style="width: 100%; display: unset">
                            <mat-toolbar-row style="width: 100%; display: grid ">
                              <button mat-raised-button (click)="customsReleaseHold()" [disabled]="cusDetails.length==0" class="blueButton" >Inspection Complete</button>
                            </mat-toolbar-row>
                            <mat-toolbar-row style="width: 100%; max-height: 15px; padding-bottom: 1%; display:contents;">
                              <div class="errorDiv2" style="font-size: 15px" *ngIf="noneSelected">Must Choose At Least 1 Container</div>
                            </mat-toolbar-row>
                          </mat-toolbar>
                        </div>

                      </div>
                    </mat-card>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</div>



<mat-card class="details" *ngIf="showScreen">
  <table style="width: 100%; height: 100%">
    <tr>

      <td class="topTd" >

              <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
                <tr>
                  <td style="width: 1%">
                    <div class="maher" (click)="leaveScreen()"></div>
                  </td>
                  <td style="width: 30%; text-align: left">
                    <div class="titleFont" style="font-size: 23px; padding-left: 0%">RPM Inspections</div>
                  </td>
                  <td style="width: 70%"></td>
                </tr>
              </table>
              <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
                <tr >
                  <td style="width: 60%">
                    <div >
                      <mat-form-field class="search"  appearance="outline" >
                        <mat-label style="padding-left: 20px;">Equipment</mat-label>
                        <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/cargo_container.png" ></mat-icon>
                        <input [(ngModel)]="containerNum" oninput="this.value = this.value.toUpperCase()"  maxlength="11" style="padding-left: 20px; font-family: Calibri; font-weight: bold"  matInput>
                      </mat-form-field>
                    </div>
                  </td>
                  <td>
                    <button mat-raised-button matTooltip="put container on hold" class="whiteButton" (click)="customsAddHold()"><img style="vertical-align: center;height:40px; width: 40px" src="assets/hold.png" > Add Hold</button>
                    <span  style="padding-left: 20px"></span>
                    <button mat-raised-button (click)="refreshScreen()" matTooltip="refresh data on screen" class="whiteButton" ><img style="vertical-align: center;height:40px; width: 35px" src="assets/refresh.png" > Refresh</button>

                  </td>
                </tr>
                <tr>
                  <td colspan="3" style="width: 100%; text-align: center; padding-bottom: 2%">
                    <div class="errorDiv2" style="font-size: 15px" *ngIf="noContainer">Please Input A Container</div>
                    <div class="errorDiv2" style="font-size: 15px" *ngIf="noContFound">Container Not Found</div>
                  </td>
                </tr>
              </table>

              <div class="flex-item2" >
                <mat-table #table23 style="width:100%" [dataSource]="customsData" multiTemplateDataRows matSort="container"  >

                  <ng-container matColumnDef="check" >
                    <mat-header-cell *matHeaderCellDef  matTooltip="click to check/uncheck all" class="myHeader"><img (click)="checkAll()" style="vertical-align: center;height:26px; width: 26px" src="assets/check_circle_white.png" ></mat-header-cell>
                    <mat-cell style="    flex: 0 0 5% !important;" *matCellDef="let row">
                      <mat-checkbox #mySel color="warn" (click)="$event.stopPropagation()"
                                     (change)="masterToggle(row,selection.isSelected(row)) ? selection.toggle(row) : null"
                                     [checked]="selection.isSelected(row)">
                      </mat-checkbox>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="container" >
                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Container</mat-header-cell>
                    <mat-cell style="    flex: 0 0 30% !important;" *matCellDef="let row">{{row.container}}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="yard" >
                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Yard</mat-header-cell>
                    <mat-cell style="    flex: 0 0 20% !important;"*matCellDef="let row">{{row.yard}}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="area" >
                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Location</mat-header-cell>
                    <mat-cell style="    flex: 0 0 20% !important;" *matCellDef="let row" >{{row.area}}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="navisErrors" >
                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Errors</mat-header-cell>
                    <mat-cell *matCellDef="let row" >{{row.navisErrors}}</mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="cColumns; sticky: true"></mat-header-row>
                  <mat-row   *matRowDef="let row; columns: cColumns;" class="table-row"></mat-row>
                </mat-table>
                <mat-toolbar style="width: 100%; display: unset">
                  <mat-toolbar-row style="width: 100%; ">
                    <button mat-raised-button (click)="customsReleaseHold()"  class="blueButton" >Inspection Complete</button>
                    <mat-paginator class="myPaginator"  [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                  </mat-toolbar-row>
                  <mat-toolbar-row style="width: 100%; max-height: 15px; padding-bottom: 1%; padding-left: 1%">
                    <div class="errorDiv2" style="font-size: 15px" *ngIf="noneSelected">Must Choose At Least 1 Container</div>
                  </mat-toolbar-row>
                </mat-toolbar>
              </div>
      </td>
      <td class="loginPic" style="">

      </td>
    </tr>
  </table>
</mat-card>
